import { get } from 'lodash';

const root = state => get(state, 'KitchenPrepWorksheetState.tabSettingsState');

export const getSelectedTab = state => get(root(state), 'selectedTab', '');



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/settings/selectors.js